module.exports = function getResource(label, vars = []) {
    const resources = {
        kilometer: 'kilomètre',
        mile: 'mille',
        away: 'absent',
        closed: 'Fermé',
        storeClosed: 'Magasin fermé',
        openUntil: `Ouvert jusqu’à ${vars[0]}`,
        getDirections: 'Obtenir l’itinéraire'
    };

    return resources[label];
};
